import { TApiOrder } from "../../api/endpoints/Order";
import React from "react";

interface IProps {
  order: TApiOrder
}

const OrderName = (props: IProps) => {
  const { order: { name } } = props;

  return (
    <span className="order-name">
      {
        name ? name : <em>(no name)</em>
      }
    </span>
  )
};

export default OrderName;
